/**
 * Appends a voice transcript to whatever is already in the box — voice never replaces a draft.
 */
export function appendTranscript(current: string | null | undefined, transcript: string): string {
  const draft = (current ?? '').trim();
  return draft ? `${draft} ${transcript}` : transcript;
}

/**
 * Scrolls a text field so the end of its value is visible, with the caret parked there.
 *
 * The browser only auto-scrolls to the caret while the user is actually typing. A programmatic
 * write — a voice transcript, or an `ngModel` push — leaves the field pinned at the top/left, so
 * a long dictation shows its head and hides the words the user just spoke. Call this after every
 * programmatic write so the field ends up exactly where typing would have left it.
 *
 * Must run after the DOM value is in place (defer it a tick when the write goes through `ngModel`).
 */
export function scrollTextFieldToEnd(el: HTMLTextAreaElement | HTMLInputElement | null | undefined): void {
  if (!el) return;
  const end = el.value.length;
  if (typeof el.setSelectionRange === 'function') el.setSelectionRange(end, end);
  el.scrollTop = el.scrollHeight;
  el.scrollLeft = el.scrollWidth;
}
